import * as React from 'react';
import { Box } from '../../designSystem/components/box';
import { Flex } from '../../designSystem/components/flex';
import { UserAssignmentsDocumentOptions } from '../../generated/types';
import { getBarcodeHref } from '../../util/url';
import { getSubtitlesStyle } from './documentInformations';

interface IDocumentQrCodeProps {
    options: Pick<
        UserAssignmentsDocumentOptions,
        'showQrCode' | 'subtitleColor' | 'titleFontFamily'
    >;
    ticketId: string;
}

export const DocumentQrCode = (props: IDocumentQrCodeProps) =>
    props.options.showQrCode ? (
        <Flex
            align="center"
            css={{
                background: 'white',
                borderRadius: '$2',
                padding: '$4 $3'
            }}
            direction="column"
            gap="3"
            width={1}
        >
            <Box
                css={{
                    ...getSubtitlesStyle(props.options),
                    textAlign: 'center'
                }}
                width={1}
            >
                QR Code
            </Box>

            <Box height={104} width={104}>
                <img
                    height="100%"
                    src={getBarcodeHref(props.ticketId, {
                        height: 90,
                        width: 90
                    })}
                    width="100%"
                />
            </Box>
        </Flex>
    ) : null;
